import React from "react";
import {
  TrophyIcon,
  EyeIcon,
  ChatBubbleBottomCenterIcon,
} from "@heroicons/react/24/outline";
import { formatNumber } from "../../../helpers/NumberFormats";

interface RapperHeroProps {
  rapperData: {
    id: string;
    slug: string;
    name: string;
    imagePath: string | null;
    shortBio: string | null;
    stats: {
      communityRank: number | null;
      listAppearances: number;
      averageRank: number | null;
      totalReactions: number;
      totalComments: number;
      debateCount: number;
      points: number;
    };
  };
}

const RapperHero: React.FC<RapperHeroProps> = ({ rapperData }) => {
  return (
    <div className="bg-gray-800/50 rounded-lg mb-8">
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
        {/* Artist Image */}
        <div className="h-full">
          <div className="w-48 h-full lg:w-56 overflow-hidden bg-gray-700 rounded-l-lg">
            {rapperData.imagePath ? (
              <img
                src={rapperData.imagePath}
                alt={rapperData.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <TrophyIcon className="w-16 h-16" />
              </div>
            )}
          </div>
        </div>

        {/* Artist Info */}
        <div className="flex-1 min-w-0 p-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-2">
                {rapperData.name}
              </h1>
              {rapperData.stats.communityRank && (
                <div className="flex items-center gap-2 mb-3">
                  <TrophyIcon className="w-6 h-6 text-yellow-500" />
                  <span className="text-xl font-semibold text-yellow-500">
                    #{rapperData.stats.communityRank} Community Rank
                  </span>
                </div>
              )}
            </div>

            {/* Primary Actions */}
            {/* <div className="flex flex-wrap gap-3 mt-4 lg:mt-0">
              <button className="btn  flex items-center gap-2">
                <HeartIcon className="w-5 h-5" />
                Add to List
              </button>
              <button className="btn-alt bg-gray-700 hover:bg-gray-600 flex items-center gap-2">
                <ChatBubbleBottomCenterIcon className="w-5 h-5" />
                Start Debate
              </button>
            </div> */}
          </div>

          {/* Short Bio */}
          {rapperData.shortBio && (
            <p className="text-gray-300 text-lg leading-relaxed mb-4 max-w-3xl">
              {rapperData.shortBio}
            </p>
          )}

          {/* Quick Stats */}
          <div className="flex flex-wrap gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <EyeIcon className="w-4 h-4" />
              <span>
                Appears in {formatNumber(rapperData.stats.listAppearances)}{" "}
                lists
              </span>
            </div>
            {rapperData.stats.averageRank && (
              <div className="flex items-center gap-2">
                <TrophyIcon className="w-4 h-4" />
                <span>Avg Rank: {rapperData.stats.averageRank.toFixed(1)}</span>
              </div>
            )}
            <div className="flex items-center gap-2">
              <ChatBubbleBottomCenterIcon className="w-4 h-4" />
              <span>{formatNumber(rapperData.stats.debateCount)} debates</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RapperHero;
